import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order order-details details" }
const _hoisted_2 = { class: "detail-top" }
const _hoisted_3 = { class: "block-header" }
const _hoisted_4 = { class: "app-wrapper" }

import DetailHeader from '@/components/DetailHeader.vue'
import OrderDetailBase from './components/OrderDetailBase.vue'
import OrderDetailMonitor from './components/OrderDetailMonitor.vue'
import OrderProfitSharing from './components/OrderProfitSharing.vue'
import useI18nTl from '@/hooks/useI18nTl'
import { ref, computed, onMounted } from 'vue'
import { useRoute } from 'vue-router'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OrderDetails',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t, tl } = useI18nTl('Order')

const route = useRoute()
const orderid = computed(function () {
  const id = route.params.id
  return Array.isArray(id) ? id[0] : id
})
const detailLock = ref(false)
const currTab = ref('base')

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(DetailHeader, {
          item: { name: _unref(orderid) + ' - ' + _unref(tl)('sessionDetail') }
        }, null, 8, ["item"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _withDirectives((_openBlock(), _createBlock(_component_el_tabs, {
        class: "detail-tabs",
        modelValue: currTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currTab).value = $event))
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Base.overview'),
            name: "base",
            lazy: true,
            key: 'base'
          }, {
            default: _withCtx(() => [
              _createVNode(OrderDetailBase, { orderId: _unref(orderid) }, null, 8, ["orderId"])
            ]),
            _: 1
          }, 8, ["label"])),
          (_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Base.monitor'),
            name: "monitor",
            lazy: true,
            key: 'monitor'
          }, {
            default: _withCtx(() => [
              _createVNode(OrderDetailMonitor, { orderId: _unref(orderid) }, null, 8, ["orderId"])
            ]),
            _: 1
          }, 8, ["label"])),
          (_openBlock(), _createBlock(_component_el_tab_pane, {
            label: _ctx.$t('Order.profitsharing'),
            name: "profitsharing",
            lazy: true,
            key: 'profitsharing'
          }, {
            default: _withCtx(() => [
              _createVNode(OrderProfitSharing, { orderId: _unref(orderid) }, null, 8, ["orderId"])
            ]),
            _: 1
          }, 8, ["label"]))
        ]),
        _: 1
      }, 8, ["modelValue"])), [
        [
          _directive_loading,
          detailLock.value,
          void 0,
          { lock: true }
        ]
      ])
    ])
  ]))
}
}

})